const constants = {
    // serverUrl: "http://localhost:3001"
    serverUrl: "https://api.party46project.syndevo.ru"
}
export default constants